import { SESSION_ID } from '../../../../../../config/session-id';
import { SpAlert } from '../../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(
        $scope,
        BarcodeGeneratonService,
        RegistrationCodeGeneratonService,
        SimulatorResource,
    ) {
        this.$scope = $scope;
        this.BarcodeGeneratonService = BarcodeGeneratonService;
        this.RegistrationCodeGeneratonService = RegistrationCodeGeneratonService;
        this.SimulatorResource = SimulatorResource;
    }

    $onInit() {
        this.$scope.$on('websocket.SAML_LOGIN', () => {
            this.irSuccess = false;
            this.ilSuccess = true;
        });
        this.$scope.$on('websocket.REGISTERED_COMPANY', () => {
            this.ilSuccess = false;
            this.irSuccess = true;
        });
    }

    loadQrDataIL() {
        return this.BarcodeGeneratonService
            .simulatorBarcode({
                uuid: SESSION_ID,
                appKey: this.application.applicationApiKey
            })
            .$promise
            .then(barcode => barcode.barcodeimage);
    }

    loadQrDataIR() {
        return this.RegistrationCodeGeneratonService
            .simulatorBarcode({
                uuid: SESSION_ID,
                appKey: this.application.applicationApiKey
            })
            .$promise
            .then(barcode => barcode.barcodeimage);
    }

    simulateManualLogin() {
        this.isLoading = true;
        this.SimulatorResource
            .simulateManualLogin(
                this.companyId,
                this.application.id,
                this.username,
                this.otp,
            )
            .then(
                () => {
                    const key = 'developers.body.simulator.otp_success';
                    this.spAlert = new SpAlert('success', key);
                },
                () => {
                    const key = 'developers.body.simulator.otp_error';
                    this.spAlert = new SpAlert('danger', key);
                }
            )
            .finally(() => this.isLoading = false);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/simulators/simulators.controller.js